import { Spinner } from '../ui/Spinner';

interface FormNavigationProps {
  step: number;
  totalSteps: number;
  onNext: () => void;
  onBack: () => void;
  onSubmit: () => void;
  canProceed: boolean;
  isSubmitting?: boolean;
}

export function FormNavigation({
  step,
  totalSteps,
  onNext,
  onBack,
  onSubmit,
  canProceed,
  isSubmitting = false,
}: FormNavigationProps) {
  const isLastStep = step === totalSteps;

  return (
    <div className="flex justify-between items-center pt-6 border-t mt-8">
      <button
        type="button"
        onClick={onBack}
        disabled={step === 1}
        className={`
          btn-secondary
          ${step === 1 ? 'invisible' : ''}
        `}
      >
        <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
        Back
      </button>

      {isLastStep ? (
        <button
          type="button"
          onClick={onSubmit}
          disabled={!canProceed || isSubmitting}
          className="btn-primary min-w-[180px]"
        >
          {isSubmitting ? (
            <>
              <Spinner size="sm" className="mr-2 text-white" />
              Generating...
            </>
          ) : (
            <>
              Generate Landing Pages
              <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 10V3L4 14h7v7l9-11h-7z"
                />
              </svg>
            </>
          )}
        </button>
      ) : (
        <button
          type="button"
          onClick={onNext}
          disabled={!canProceed}
          className="btn-primary"
        >
          Continue
          <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      )}
    </div>
  );
}
